<script setup>
import Step from "@Components/Stepper/Step.vue";
import { useI18n } from "vue-i18n";
import ClassicContentModule from "@Pages/Projects/Shared/Modules/ClassicContentModule.vue";
import SettingsSidebar from "@Pages/Projects/Shared/SettingsSidebar.vue";
import UseTemplateModal from "@Components/Templates/UseTemplateModal.vue";
import { ref } from "vue";
import _cloneDeep from "lodash/cloneDeep";
import _merge from "lodash/merge";
import { PrimaryButton } from "@Components/Button";
import CustomContentModule from "@Pages/Projects/Shared/Modules/CustomContentModule.vue";

const props = defineProps(["modelValue", "step", "personas", "templates", "statuses", "categories", "postTypes", "users"]);
defineEmits(["update:modelValue", "next", "back", "skip"]);

const { t: __ } = useI18n();
const useTemplateModal = ref();

const useTemplate = (template) => {
    // empty all array settings
    props.modelValue.modules.content.blocks = [];
    props.modelValue.modules.content.automatic.custom_links.links = [];
    props.modelValue.modules.content.automatic.keywords.custom = [];
    props.modelValue.modules.wordpress.categories.custom = [];
    props.modelValue.modules.wordpress.tags.custom = [];
    props.modelValue.modules.wordpress.custom_fields = [];

    props.modelValue.modules = _merge(props.modelValue.modules, _cloneDeep(template.payload.modules));
    props.modelValue.persona_id = template.payload.persona_id;

    useTemplateModal.value.hide();
};
</script>

<template>
    <Step :step="step" :processing="modelValue.processing" @next="$emit('next')" @back="$emit('back')" @skip="$emit('skip')" class="relative lg:px-8 sm:px-6">
        <template #header>
            <div class="mx-auto max-w-3xl">
                <h3 class="text-4xl font-semibold leading-tight text-center text-gray-900 dark:text-white">
                    {{ __("Configurez vos contenus à plannifier") }}
                </h3>
            </div>
        </template>

        <div class="mx-auto flex flex-col space-y-6">
            <div class="flex justify-end space-x-3 lg:px-8">
                <PrimaryButton @click.prevent="$refs.useTemplateModal.show()">{{ __("Utiliser un template") }}</PrimaryButton>
                <UseTemplateModal ref="useTemplateModal" @use="useTemplate" />
                <PrimaryButton v-if="modelValue.modules.content.automatic.enabled" @click="modelValue.modules.content.automatic.enabled = false">{{
                    __("Mode avancé")
                }}</PrimaryButton>
                <PrimaryButton v-else @click="modelValue.modules.content.automatic.enabled = true">{{ __("Mode classique") }}</PrimaryButton>
            </div>

            <ClassicContentModule
                v-if="modelValue.modules.content.automatic.enabled"
                :modelValue="modelValue"
                @update:modelValue="$emit('update:modelValue', $event)"
                :personas="personas" />
            <CustomContentModule v-else :modelValue="modelValue" @update:modelValue="$emit('update:modelValue', $event)" :personas="personas" />

            <SettingsSidebar
                :modelValue="modelValue"
                @update:modelValue="$emit('update:modelValue', $event)"
                :templates="templates"
                :statuses="statuses"
                :categories="categories"
                :postTypes="postTypes"
                :users="users" />
        </div>
    </Step>
</template>
